import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import rejectIcon from '../../../assets/images/Error-Close-Filled.png'
import flightIcon from '../../../assets/images/plane-filled-blue.png'
import pendingIcon from '../../../assets/images/Pending_icon.svg'
import menuDots from '../../../assets/images/more-icon.svg'
import envConfigs from '../../../configs/envConfigs'
import {
	BOOKING_STATUSES,
	MENU_ITEMS_BOOKING,
	NOTIFICATION_MESSAGE_TYPE,
	WEIGHT_UNIT_SELECT_ITEMS,
} from '../../../constants'
import MESSAGES from '../../../constants/Messages'
import PaginatorComponent from '../../Pagination/PaginatorComponent'
import './booking-details.scss'
const BookingDetailsList = ({
	initialSearch,
	setInitialSearch,
	listBookingResponse,
	listBookingError,
	getPaginatedBookingResults,
	setNotificationMessage,
	setNotificationType,
}) => {
	//FOR MULTILINGUAL
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	const [bookingList, setBookingList] = useState([])
	const [pageIndex, setPageIndex] = useState(1)
	const [currentPage, setCurrentPage] = useState(0)
	const [startIndex, setStartIndex] = useState(0)
	const [endIndex, setEndIndex] = useState(0)
	const [totalRecordCount, setTotalRecordCount] = useState(0)
	const history = useHistory()
	const rowCount = 10
	const recordsPerRequest = 100
	const initialPageNumber = 1
	const [routes, setRoutes] = useState('')
	const [calculatedPageNumber, setCalculatedPageNumber] = useState(1)
	const [showDropdown, setShowDropdown] = useState(false)
	const [key, setKey] = useState(null)
	const { parentUrl } = envConfigs
	let i18nLang = localStorage.getItem('i18nextLng');
	const [pageCount, setPageCount] = useState('')
	moment.updateLocale(i18nLang.toString(), {
		weekdays: [t('COMMON.SUN'), t('COMMON.MON'), t('COMMON.TUE'), t('COMMON.WED'), t('COMMON.THU'), t('COMMON.FRI'), t('COMMON.SAT')
		],
		weekdaysShort: [
			t('COMMON.SUN_SHORT'), t('COMMON.MON_SHORT'), t('COMMON.TUE_SHORT'), t('COMMON.WED_SHORT'), t('COMMON.THU_SHORT'), t('COMMON.FRI_SHORT'), t('COMMON.SAT_SHORT')
		]
	});

	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			const clickWrapper = event.target.closest('.menu-dot-wrapper');

			if (dropdownRef.current &&
				!dropdownRef.current.contains(event.target) &&
				!clickWrapper) {
				setShowDropdown(false);
			}
		};

		if (showDropdown) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [showDropdown]);

	useEffect(() => {
		if (listBookingResponse) {
			setBookingList(listBookingResponse.bookingList);
			setTotalRecordCount(listBookingResponse.totalRecordCount);

			// Calculate pages per chunk
			const pagesPerChunk = recordsPerRequest / rowCount;
			let modulusOfPageIndex = pageIndex % pagesPerChunk;

			// If modulus is 0, it's the last page of the chunk
			if (modulusOfPageIndex === 0) {
				modulusOfPageIndex = pagesPerChunk;
			}
			const start = (modulusOfPageIndex - 1) * rowCount;
			const end = modulusOfPageIndex * rowCount
			const startRowCount = start + 1;
			const endRowCount = end > listBookingResponse.totalRecordCount ? listBookingResponse.totalRecordCount : end;

			setPageCount(`${startRowCount} - ${endRowCount}`);

			setStartIndex(start);
			setEndIndex(end);
		}
	}, [listBookingResponse, pageIndex]);

	// useEffect(() => {
	// 	if (listBookingResponse) {
	// 		setBookingList(listBookingResponse.bookingList)
	// 		setTotalRecordCount(listBookingResponse.totalRecordCount)
	// 		let modulusOfPageIndex = pageIndex % (recordsPerRequest / rowCount)	

	// 		if (modulusOfPageIndex === 0) {
	// 			modulusOfPageIndex = 3
	// 			setStartIndex((modulusOfPageIndex - 1) * rowCount)
	// 			setEndIndex(modulusOfPageIndex * rowCount)
	// 		} else {
	// 			setStartIndex((modulusOfPageIndex - 1) * rowCount)
	// 			setEndIndex(modulusOfPageIndex * rowCount)
	// 		}
	// 	}
	// }, [listBookingResponse, pageIndex])

	useEffect(() => {
		if (initialSearch) {
			setPageIndex(1)
			setCurrentPage(0)
		}
	}, [initialSearch])

	useEffect(() => {
		if (calculatedPageNumber >= initialPageNumber) {
			getPaginatedBookingResults(calculatedPageNumber)
		}
	}, [calculatedPageNumber])

	const onPageIndexChange = (newPageIndex, currentPageToDisplay) => {
		setPageIndex(newPageIndex)
		setCurrentPage(currentPageToDisplay)
		setInitialSearch(false)
		const calculatedPageNumber = Math.ceil(
			(newPageIndex * rowCount) / recordsPerRequest
		)

		setCalculatedPageNumber(calculatedPageNumber)
		// if (calculatedPageNumber >= initialPageNumber) {
		// 	getPaginatedBookingResults(calculatedPageNumber)
		// }
	}

	const handleViewBooking = (bookingDetail) => {

		history.push(
			`/manage-booking/${bookingDetail.shipmentIdentifierDetails.shipmentPrefix}
			${bookingDetail.shipmentIdentifierDetails.masterDocumentNumber}/${bookingDetail.ubrNumber}`
		)
	}

	// const redirectToTrackOrCopyBooking = (evnt, result, option) => {
	// 	evnt.stopPropagation()
	// 	if (result.bookingStatus === 'X') {
	// 		setNotificationMessage(MESSAGES.ALREDAY_CANCELLED)
	// 		setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR)
	// 		window.scrollTo(0, 0)
	// 	} else {
	// 		const airwayBill = result.shipmentIdentifierDetails
	// 			? result.shipmentIdentifierDetails.shipmentPrefix +
	// 			result.shipmentIdentifierDetails.masterDocumentNumber
	// 			: ''
	// 		if (option === MENU_ITEMS_BOOKING.TRACK) {
	// 			window.open(
	// 				`${parentUrl ? parentUrl : 'https://www.etihadcargo.com'
	// 				}/en/e-services/track-shipment?awb=${airwayBill}`,
	// 				'_blank'
	// 			)
	// 		} else if (option === MENU_ITEMS_BOOKING.COPY) {
	// 			history.push(`/booking/search/${airwayBill}`)
	// 			window.scrollTo(0, 0)
	// 		}
	// 	}
	// }

	const redirectToTrackOrCopyBooking = (evnt, result, option) => {
		evnt.stopPropagation();
		if (result.bookingStatus === 'X') {
			setNotificationMessage(MESSAGES.ALREDAY_CANCELLED);
			setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
			window.scrollTo(0, 0);
		} else {
			const airwayBill = result.shipmentIdentifierDetails
				? result.shipmentIdentifierDetails.shipmentPrefix +
				result.shipmentIdentifierDetails.masterDocumentNumber
				: '';
			if (option === MENU_ITEMS_BOOKING.TRACK) {
				const language = i18n.language ? i18n.language : 'en'
				window.open(
					`${parentUrl ? parentUrl : 'https://www.etihadcargo.com'
					}/${language}/e-services/shipment-tracking?awb=${airwayBill}`,
					'_blank'
				)
				setShowDropdown(false)
			} else if (option === MENU_ITEMS_BOOKING.COPY) {
				const shipmentSccs = result.shipmentSccs || [];
				history.push({
					pathname: `/booking/search/${airwayBill}`,
					state: {
						isCopyFlow: true,
						shipmentSccs: shipmentSccs,
					}
				});
				window.scrollTo(0, 0)
			}
		}
	}

	const getRoutes = (flightSegments) => {
		if (flightSegments.length > 0) {
			return flightSegments.length - 1
		} else return 0
	}

	const getFormatedTime = (value) => {
		let formattedTime = ''
		if (value) {
			let tempArray = value.split(':')
			formattedTime =
				parseInt(tempArray[0], 10) +
				'Hrs ' +
				(tempArray[1] && tempArray[1] != '00' ? tempArray[1] + ' Min' : '')
		}
		return formattedTime
	}

	const formatCityName = (city) => {
		if (!city) return '';
		return city
			.toLowerCase()
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	return (
		<div id='BookingDetailsList' className={`mt-3 mt-lg-5 mb-3 ${isRTL ? 'rtl' : ''}`}>
			<h3 className='page-sub-head mb-1'> {t('COMMON.BOOKING LIST')}</h3>
			{listBookingResponse && totalRecordCount > 0 && (
				<div className='form-row mb-4 booking-details__total-results-display'>
					<div className='col-12 d-flex justify-content-between align-items-center'>
						<div className='booking-details-count'>
							{totalRecordCount}
							{''} {totalRecordCount > 1 ? t('COMMON.BOOKINGS') : ''}
							{totalRecordCount === 1 && t('COMMON.BKG_HEAD')}
						</div>
						<div className='page-details-text'>
							{t('COMMON.SHOWING')} {pageCount} {t('COMMON.OF')} {totalRecordCount}
						</div>
					</div>
				</div>
			)}

			{listBookingResponse && bookingList.length === 0 && (
				<div className='no-data ml-0 mr-0'>
					{' '}
					{t(MESSAGES.NO_BOOKINGS, { ns: 'errors' })}
				</div>
			)}

			{!listBookingResponse && !listBookingError && (
				<div className='no-data m-0'>
					{t(MESSAGES.LOADING, { ns: 'errors' })}
				</div>
			)}

			{listBookingError && (
				<div className='no-data m-0'>
					{t(MESSAGES.PROCESS_REQUEST_FAILED, { ns: 'errors' })}
				</div>
			)}

			{listBookingResponse &&
				bookingList.length >= 1 &&
				bookingList.slice(startIndex, endIndex).map((result, index) => (
					<div
						className='booking-details__inner-wrapper'
						key={index}
					// onClick={() => handleViewBooking(result)}
					>
						<div className={`form-row booking-details__item ${isRTL ? 'rtl' : ''}`}>
							<div className='w-100 pl-0 pr-0' style={{ cursor: "default" }}>
								{/* --- First Row: AWB/Status (left) and Menu Dots (right) --- */}
								<div className="">
									<div className='booking-details__header d-flex justify-content-between align-items-center'>
										<div className=" awb-status-wrapper d-flex flex-row mb-0">
											{result.shipmentIdentifierDetails ? (
												<div className='awb-text'>
													{result.shipmentIdentifierDetails.shipmentPrefix}-
													{result.shipmentIdentifierDetails.masterDocumentNumber}
												</div>
											) : null}
											{/* <div className='flight-status-wrapper'>
											<span
												className={
													result.bookingStatus === 'C'
														? 'confirm-tick-mark '
														: result.bookingStatus === 'Q'
															? 'pr-3'
															: 'reject-status'
												}
											>
												{result.bookingStatus === 'Q' && (
													<i className='pr-1 indicator'>
														<img
															src={pendingIcon}
															alt='pending'
															className='image-wrapper'
														/>
													</i>
												)}
												{result.bookingStatus === 'X' && (
													<i>
														<img
															src={rejectIcon}
															alt='Rejected'
															className='image-wrapper'
														/>
													</i>
												)}
												{t(BOOKING_STATUSES[result.bookingStatus])}
											</span>
										</div> */}

											<div className='flight-status-wrapper'>
												<span
													className={
														result.bookingStatus === 'C'
															? 'status-badge list-booking-status-confirmed'
															: result.bookingStatus === 'Q'
																? 'status-badge list-booking-status-queued'
																: 'status-badge list-booking-status-rejected'
													}
												>
													<span className={`status-dot ${isRTL ? 'rtl' : ''}`}></span>
													<span>
														{t(BOOKING_STATUSES[result.bookingStatus])}
													</span>
												</span>
											</div>

										</div>
										<div className="col-auto booking-details__right-track d-flex justify-content-end">
											<button
												type="button"
												className="btn-link p-0 mr-2"
												onClick={() => handleViewBooking(result)}

											>
												{t('COMMON.VIEW')}
											</button>
											<div id='menu-dots'>
												<div
													className='menu-dot-wrapper'
													onClick={(e) => {
														e.stopPropagation();
														setShowDropdown(!showDropdown);
														setKey(index);
													}}
												>
													<i>
														<img
															src={menuDots}
															alt=''
														/>
													</i>
												</div>
												{showDropdown && key === index &&
													<div className='menuDot-dropdown' ref={dropdownRef}>
														<ul className='dropdown-panel'>
															<li
																className='panel-first-item'
																onClick={(evnt) => redirectToTrackOrCopyBooking(evnt, result, MENU_ITEMS_BOOKING.TRACK)}>
																{t('COMMON.TRACK')}
															</li>
															<li className='panel-item'
																onClick={(evnt) => redirectToTrackOrCopyBooking(evnt, result, MENU_ITEMS_BOOKING.COPY)}>
																{t('BKGLIST.COPY')}
															</li>
														</ul>
													</div>
												}
											</div>
										</div>
									</div>
								</div>
								{/* --- Second Row: Flight Section (full width) --- */}
								<div className="">
									<div className="booking-details__flight-section" style={{ width: '100%' }}>
										<div className='booking-details__route'>

											<ul className='flight-details__timing'>

												<li className='booking-details__departure '>
													<div className='origin_airport_name'>{formatCityName(result.originCity)}</div>
													<div className='origin_text'>{result.origin}</div>
													{result.flightSegments &&
														result.flightSegments[0] &&
														result.flightSegments[0].segmentDepartureDate && (
															<div className='departure_time'>
																{moment(result.flightSegments[0].segmentDepartureDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
															</div>
														)}
													<div className='booking-details__p-b-6'>
														{moment(result.shippingDate, 'DD-MMM-YYYY').format(
															'DD MMM'
														)}
													</div>
												</li>
												<div className='flight-details__connection booking-details-connection'>
													<div className='booking-details-timeline-track'>
														<div className='origin-destination-icon manage-booking-origin-destination-icon dark'></div>
														<div className='transit-line booking-details-transit-line' />
														<div className='iconsSection booking-details-icon-section'>
															<i>
																<img
																	src={flightIcon}
																	alt='Flight'
																	title='Flight'
																/>
															</i>
														</div>
														<div className='transit-line booking-details-transit-line' />
														<div className='origin-destination-icon manage-booking-origin-destination-icon dark'></div>
													</div>

													{getRoutes(result.flightSegments) === 1 ? (
														<span className='flight-details__routes booking-details-stops m-0'>
															<span className='booking-details-stops'>
																{getRoutes(result.flightSegments)}{' '}
																{t('CHOOSE_FLT.STOP')}
															</span>
														</span>
													) : getRoutes(result.flightSegments) > 1 ? (
														<span className='flight-details__routes booking-details-stops m-0'>
															<span className='booking-details-stops'>
																{getRoutes(result.flightSegments)}{' '}
																{t('CHOOSE_FLT.STOPS')}
															</span>
														</span>
													) : null}
													<div className='duration'>
														<div className='duration-flying-hours-manage-booking'>{getFormatedTime(result.cumulativeJourneyTime)}</div>
													</div>

												</div>
												<li className='flight-details__arrival booking-details__arrival '>
													<div className='destination_airport_name'>{formatCityName(result.destinationCity)}</div>
													<div className='destination_text'>{result.destination}</div>
													<div className='destination-time'>
														{result.flightSegments.length > 1
															? result.flightSegments[result.flightSegments.length - 1]?.segmentArrivalDate && (
																<div className='departure_time'>
																	{moment(result.flightSegments[result.flightSegments.length - 1].segmentArrivalDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
																</div>
															)
															: result.flightSegments[0]?.segmentArrivalDate && (
																<div className='departure_time'>
																	{moment(result.flightSegments[0].segmentArrivalDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
																</div>
															)}
														{/* {result.flightSegments &&
														result.flightSegments[0] &&
														result.flightSegments[0].segmentArrivalDate && (
															<div className='departure_time'>
																{moment(result.flightSegments[0].segmentArrivalDate, 'DD-MMM-YYYY HH:mm:ss').format('HH:mm')}
															</div>
														)} */}
														<div className='booking-details__p-b-6'>
															{moment(result.arrivalDate, 'DD-MMM-YYYY').format(
																'DD MMM'
															)}
														</div>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
								{/* --- Third Row: Commodity Details --- */}
								<div className="">
									<div className='booking-details__footer'>
										<div className='col-12 booking-details__commodity-details'>
											<div className='pb-lg-1 custm_pt'>{result.commodity}</div>
											<div className='commodity-details-separator'></div>
											{result.product && (
												<div className='pb-lg-1 custm_pt'>{result.product}</div>
											)}
											<div className='commodity-details-separator'></div>
											<div>
												<div className='commodity-inner-wrapper d-block d-lg-inline custm_pt'>
													<span>{result.pieces}Pcs -</span>
													{WEIGHT_UNIT_SELECT_ITEMS.map(
														(weightUnit, idx) => {
															return weightUnit.value ===
																result.weightUnit ? (
																<span key={idx}>
																	{result.weight}
																	{weightUnit.label}
																</span>
															) : (
																<span key={idx}></span>
															)
														}
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}



			{listBookingResponse && bookingList.length !== 0 && (
				<div className='paginationWrapper'>
					<PaginatorComponent
						initialSearch={initialSearch}
						currentPage={currentPage}
						pageIndex={pageIndex}
						rowCount={rowCount}
						totalRecords={totalRecordCount}
						onPageIndexChange={onPageIndexChange}
					/>
				</div>
			)}
		</div>
	)
}

export default BookingDetailsList
